<template>
  <div class="manage-site">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Customer</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="item in sites">
            <div
              class="row clickable"
              :key="item.id"
              v-show="
                item.active == !show_deleted && item.customer_id == customer_id
              "
              v-bind:class="{ selected: item == site }"
              @click="_siteSelected(item)"
            >
              <div class="col-12">
                {{ item.name }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <SiteDetail
            :site="site"
            class="col-12"
            ref="site_detail"
            @new="_new"
          />
          <NewSiteModal
            ref="new_site_modal"
            v-show="showNewSiteModal"
            @close="_closeNewSiteModal"
            :customer_id="customer_id"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import SiteDetail from "@/components/admin/site/SiteDetail.vue";
import NewSiteModal from "@/components/admin/site/NewSiteModal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Sites",
  props: {
    customer_id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    site: null,
    loading: false,
    show_deleted: false,
    showNewSiteModal: false,
  }),
  computed: {
    ...mapState("sites", ["sites", "new_site"]),
  },
  watch: {
    customer_id() {
      this.site = null;
    },
    new_site(new_value) {
      this.site = new_value;
      this.$refs.new_site_modal.clear();
    },
  },
  methods: {
    ...mapActions("sites", ["apiSaveSite", "apiCreateSite"]),
    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },
    _save() {
      this.$refs.site_detail.save();
    },
    _new() {
      this.showNewSiteModal = true;
    },
    _closeNewSiteModal() {
      this.showNewSiteModal = false;
    },
    _showTab(index) {
      this.tab = index;
    },
    _siteSelected(site) {
      this.site = site;
      this.$emit("site_selected", site);
    },
    _delete() {
      if (this.site != null && this.site.id > 0) {
        this.site.active = !this.site.active;
        this.apiSaveSite(this.site);
      }
    },
  },
  components: {
    SiteDetail,
    NewSiteModal,
  },
};
</script>
